<template>
  <AppDialog
    v-if="displayDialog"
    show
    :title="title"
    append-to-body
    class="app-informational-dialog"
    @close="dismiss"
  >
    <template #icon>
      <div class="title">
        <div class="icon">
          <i class="fa fa-bolt"></i>
          <span class="text">Popular</span>
        </div>
      </div>
    </template>
    <section class="content">
      {{ message.text }}
      <div class="illustration">
        <img :src="illustrationSrc" />
      </div>

      <div class="lines-wrapper">
        <div class="step-line"></div>
      </div>

      <div
        v-for="(value, index) in Object.values(features)"
        :key="index"
        class="list"
      >
        <div class="step-segments-wrapper">
          <div
            :class="[
              'step-segment',
              { 'is-first': index === 0, 'is-last': index === Object.values(features).length - 1 },
            ]"
          >
            <div class="step-number-wrapper">
              <div class="step-number">{{ index + 1 }}</div>
            </div>
          </div>
        </div>
        <div class="step-info">{{ value }}</div>
      </div>

      <div class="footer">
        <slot name="primaryCta">
          <a
            :href="primaryCta.url"
            class="btn btn-primary primary-cta"
            @click="$emit('cta-clicked')"
          >
            {{ primaryCta.text }}
          </a>
        </slot>
        <div class="dismiss">
          <AppCheckbox
            v-model="dontShowAgain"
            class="dismiss-checkbox"
          ><span class="text">Don't show this again</span></AppCheckbox>
        </div>
      </div>
    </section>
  </AppDialog>
</template>

<script>
import { DIALOG_BANNER_ILLUSTRATIONS } from '~/app_constants';

export default {
  name: 'AppInformationalDialog',
  props: {
    title: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    illustration: {
      type: String,
      required: true,
    },
    features: {
      type: Object,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
    primaryCta: {
      type: Object,
      required: true,
    },
    dialogVisibilityParam: {
      type: String,
      default: null,
    },
    analyticsInfo: {
      type: Object,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    dontShowAgain: false,
  }),
  computed: {
    illustrationSrc() {
      return DIALOG_BANNER_ILLUSTRATIONS[this.illustration];
    },
    displayDialog() {
      if (this.dialogVisibilityParam === null) {
        return true;
      }
      const params = new URLSearchParams(window.location.search);

      return params.get(this.dialogVisibilityParam) === 'true';
    },
  },
  methods: {
    dismiss() {
      if (this.dontShowAgain) {
        this.$emit('dismiss-promotion', 'dialog', { dismissed_item: this.page });
      }
      this.$emit('close');
    },
  },
};
</script>
